import { Message } from '@/utils/Message'

export class RMBBigTransForm {
   static NUM = '零壹贰叁肆伍陆柒捌玖';
   static UNIT = '仟佰拾个';
   static GRADEUNIT = '仟万亿兆';
   static DOTUNIT= '角分厘';
   static GRADE = 4;
   static SIGN= '￥';

   static toBigAmt(amount = 0) {
     const val = !isNaN(amount) ? Math.abs(amount) : amount
     const amt = String(val)
     let dotPart = '' // 取小数位
     let intPart = '' // 取整数位
     const dotPos = amt.indexOf('.')
     if (dotPos > -1) {
       intPart = amt.substring(0, dotPos)
       dotPart = amt.substring(dotPos + 1)
     } else {
       intPart = amt
     }
     if (intPart.length > 16) {
       Message.warning('The amount is too big.')
       return
     }
     const intBig = this.intToBig(intPart)
     const dotBig = this.dotToBig(dotPart)
     // 以下代码稍做修改，现在是完美的代码啦！
     if (dotBig.length === 0 && intBig.length !== 0) {
       return intBig + '元整'
     } else if (dotBig.length === 0 && intBig.length === 0) {
       return intBig + '零元'
     } else if (dotBig.length !== 0 && intBig.length !== 0) {
       return intBig + '元' + dotBig
     } else {
       return dotBig
     }
   }

   static dotToBig(dotPart = '') {
     if (!dotPart) return ''
     // 得到转换后的大写（小数部分）
     let strRet = ''
     for (let i = 0; i < dotPart.length && i < 3; i++) {
       let num
       if ((num = parseInt(dotPart.substring(i, i + 1))) !== 0) {
         strRet += this.NUM.substring(num, num + 1) + this.DOTUNIT.substring(i, i + 1)
       }
     }
     return strRet
   }

   static intToBig(intPart = '') {
     if (!intPart) return ''
     // 得到转换后的大写（整数部分）
     let grade = 0 // 级长
     let result = ''
     let strTmp = ''

     // 得到当级长
     grade = parseInt(String(intPart.length / this.GRADE))
     // 调整级次长度
     if (intPart.length % this.GRADE !== 0) {
       grade += 1
     }
     // 对每级数字处理
     for (let i = grade; i >= 1; i--) {
       strTmp = this.getNowGradeVal(intPart, i)// 取得当前级次数字
       result += this.getSubUnit(strTmp)// 转换大写
       result = this.dropZero(result)// 除零
       // 加级次单位
       if (i > 1) { // 末位不加单位 // 单位不能相连续
         if (this.getSubUnit(strTmp) === '零零零零') {
           result += '零' + this.GRADEUNIT.substring(i - 1, i)
         } else {
           result += this.GRADEUNIT.substring(i - 1, i)
         }
       }
     }
     return result
   }

   static getNowGradeVal(strVal = '', grade = 0) {
     // 得到当前级次的串
     let rst = ''
     if (strVal.length <= grade * this.GRADE) {
       rst = strVal.substring(0, strVal.length - (grade - 1) * this.GRADE)
     } else {
       rst = strVal.substring(strVal.length - grade * this.GRADE, strVal.length - (grade - 1) * this.GRADE)
     }
     return rst
   }

   static getSubUnit(strVal) {
     // 数值转换
     let rst = ''
     for (let i = 0; i < strVal.length; i++) {
       const s = strVal.substring(i, i + 1)
       const num = parseInt(s) // Integer.parseInt();
       if (num === 0) {
         // “零”作特殊处理
         if (i !== strVal.length) {
           // 转换后数末位不能为零
           rst += '零'
         }
       } else {
         // If IntKey = 1 And i = 2 Then
         // “壹拾”作特殊处理
         // “壹拾”合理
         // Else
         rst += this.NUM.substring(num, num + 1)
         // End If
         // 追加单位
         if (i !== strVal.length - 1) {
           // 个位不加单位
           rst += this.UNIT.substring(i + 4 - strVal.length, i + 4 - strVal.length + 1)
         }
       }
     }
     return rst
   }

   static dropZero(strVal = '') {
     // 去除连继的“零”
     let strRst
     let strBefore // 前一位置字符
     let strNow // 现在位置字符

     strBefore = strVal.substring(0, 1)
     strRst = strBefore

     for (let i = 1; i < strVal.length; i++) {
       strNow = strVal.substring(i, i + 1)
       if (strNow === '零' && strBefore === '零') {
         // 同时为零
       } else {
         strRst += strNow
       }
       strBefore = strNow
     }
     // 末位去零
     if (strRst.substring(strRst.length - 1, strRst.length) === '零') {
       strRst = strRst.substring(0, strRst.length - 1)
     }
     return strRst
   }
}
